export type DocumentoParaAssinatura = {
  id: string;
  titulo: string;
  assunto: string;
  preview_url?: string | null;
  created_at: string;
};

export const getDocumentosPendentesAssinatura = (
  request: {
    documentos_para_assinatura?: DocumentoParaAssinatura[];
  } | null | undefined,
  signedIds: Set<string> = new Set(),
): DocumentoParaAssinatura[] =>
  getDocumentosParaAssinatura(request).filter(doc => !signedIds.has(doc.id));

export const getDocumentosParaAssinatura = (
  request: {
    documentos_para_assinatura?: DocumentoParaAssinatura[];
  } | null | undefined,
): DocumentoParaAssinatura[] => request?.documentos_para_assinatura ?? [];

export const countDocumentosParaAssinatura = (
  request: {
    documentos_para_assinatura?: DocumentoParaAssinatura[];
  } | null | undefined,
  signedIds: Set<string> = new Set(),
): number => getDocumentosPendentesAssinatura(request, signedIds).length;
